module.exports = __webpack_public_path__ + "img/onthego.ee005aa1.png";